<div>
  <dx-button
    class="theme-button"
    stylingMode="text"
    [icon]="'fas fa-euro-sign'"
    (onClick)="onButtonClick()"
    hint="Go to Schedule of Charges"
  />
</div>
